import { render, staticRenderFns } from "./ApprovalNotification.vue?vue&type=template&id=bb787cf0"
import script from "./ApprovalNotification.vue?vue&type=script&lang=js"
export * from "./ApprovalNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports